export default __webpack_public_path__ + "static/media/groinPelvicPain.7a7b91ee.png";